import { render, staticRenderFns } from "./DLJZ.vue?vue&type=template&id=3a5bcb98&scoped=true&"
import script from "./DLJZ.vue?vue&type=script&lang=js&"
export * from "./DLJZ.vue?vue&type=script&lang=js&"
import style0 from "./DLJZ.vue?vue&type=style&index=0&id=3a5bcb98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5bcb98",
  null
  
)

export default component.exports